import { SubscriptionStatusEnum } from "@syadem/kairos-subscription-js";
import { some } from "lodash-es";
import { useEffect, useMemo, useState } from "react";
import { useSubscriptionOrganizations } from "../../../store";
import { useI18n } from "../../hooks/useI18n";
import { PageLayout } from "../../layout/PageLayout";
import { SubscriptionRequired } from "../organization/subscription/SubscriptionRequired";
import { useCountryConfig } from "../../hooks/useCountryConfig";
import { useConfig } from "../../hooks/useConfig";

export function IndexMentor() {
  const { t, locale } = useI18n();
  const { subscription } = useCountryConfig();
  const subscriptionOrganizations = useSubscriptionOrganizations();
  const { mentorUrl } = useConfig();
  const [iframeHeight, setIframeHeight] = useState<number>(500);

  useEffect(() => {
    if (subscription) {
      subscription.queries.subscriptionOrganizationsQuery.call();
    }
  }, [subscription]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== new URL(mentorUrl).origin) return;

      switch (event.data?.type) {
        case "documentOpen":
          if (event.data?.data?.url) {
            window.open(event.data.data.url, "_blank", "noopener,noreferrer");
          }
          break;
        case "heightChange":
          if (event.data.data?.height && typeof event.data.data.height === "number") {
            setIframeHeight(Math.max(event.data.data.height + 20, 500));
          }
          break;
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [mentorUrl]);

  const mentorLocale = useMemo(() => {
    switch (locale) {
      case "fr":
        return "fr";
      case "en-gb":
        return "en";
    }
  }, [locale]);

  if (
    subscriptionOrganizations &&
    (Object.keys(subscriptionOrganizations).length == 0 ||
      !some(
        Object.entries(subscriptionOrganizations),
        ([_, o]) =>
          o.subscription.status == SubscriptionStatusEnum.Active ||
          o.subscription.status == SubscriptionStatusEnum.Trialing,
      ))
  ) {
    return (
      <PageLayout title={t("payment.title")}>
        <SubscriptionRequired subscriptionOrganizations={subscriptionOrganizations} />
      </PageLayout>
    );
  }

  return (
    <PageLayout title={t("mentor.title")}>
      <iframe
        src={`${mentorUrl}/iframe?travel=true&pro=true&lang=${mentorLocale}&prevent-iframe-scroll=true`}
        width="100%"
        height={iframeHeight}
        title="Mentor par MesVaccins.net"
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads"
        loading="lazy"
        style={{ overflow: "hidden", border: 0 }}
      ></iframe>
    </PageLayout>
  );
}
